import React, { useMemo, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { deletejob, getJob } from "service/api";
// import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import Swal from "sweetalert2";
import Preloader from "components/Preloader/Preloader";



function DatatableTables() {
    const [alluserlist, setallusers] = useState({ users: [] });
    // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    // const [selectedDeleteData, setSelectedDeleteData] = useState(null)
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();


    useEffect(() => {
        getallusers();
    }, []);

    const getallusers = async () => {
        try {
            let response = await getJob();
            if (response.error) {
                console.log('Error while fetching data:', response.error);
            } else {
                setallusers({ users: response.data });
                //console.log(response.data);
            }
        } catch (error) {
            console.log("Error while fetching data:", error)
        } finally {
            setLoading(false);
        }
    }

    const deletePCAREDetails = async (id) => {

        Swal.fire({
            title: 'Are you sure?',
            text: 'Are you sure you want to delete this Job Form ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deletejob(id);
                    setallusers({ users: alluserlist.users.filter(site => site._id !== id) });

                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Job Form deleted successfully!',
                    });
                    getallusers();
                } catch (error) {
                    console.error('Error deleting Job Form:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: 'Failed to delete Job Form.',
                    });
                }
            }
        });
    };



    const columns = useMemo(
        () => [
            {
                Header: 'Sr no.',
                accessor: (_row, i) => i + 1,
                id: 'srno',
                Cell: ({ value }) => <span>{value}</span>,
            },
            {
                Header: 'JOB Reference No.',
                accessor: 'vc_reference',
                Cell: ({ value }) => <span style={{ color: '#DC4C64', fontWeight: '600' }}>{value || '—'}</span>,
            },
            {
                Header: 'Patient Name',
                accessor: 'patient_name',
            },
            {
                Header: 'Contact No.',
                accessor: 'contactno',
            },

            {
                Header: 'Practice',
                accessor: 'practisc_name',
            },
            {
                Header: 'Actions',
                accessor: 'id',
                Cell: ({ row }) => (
                    <div style={{ display: 'flex' }}>
                        <Link
                            className="btn btn-warning ml-2"
                            to={`/Fullviewjobform/${row.original._id}`}
                        >
                            <i className="mdi mdi-eye ml-2"></i>
                        </Link>
                        <div style={{ marginRight: '10px' }}></div>
                        <button
                            type="button"
                            className="btn btn-primary ml-2"
                            title="Create Lab Order"
                            onClick={() => navigate('/Addlab', {
                                state: {
                                    vc_reference: row.original.vc_reference,
                                    practisc_name: row.original.practisc_name,
                                    patient_name: row.original.patient_name,
                                    patientID: row.original.patientID,
                                }
                            })}
                        >
                            <i className="mdi mdi-flask-outline ml-2"></i>
                        </button>
                        <div style={{ marginRight: '10px' }}></div>
                        <button
                            type="button"
                            className="btn btn-danger ml-2"
                            onClick={() => deletePCAREDetails(row.original._id)}
                        >
                            <i className="mdi mdi-trash-can font-size-15"></i>
                        </button>
                    </div>
                ),
            },
        ],
        []
    );
    //meta title
    document.title = "Reg Job | List";

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="page-title">Jobs</h3>
                    <Link to="/addJobform" className="btn btn-primary">ADD NEW JOB</Link>
                </div>
                {/* <Breadcrumbs title="Setting" breadcrumbItem="Register Job" /> */}
                <div>
                    <TableContainer
                        columns={columns}
                        data={alluserlist.users}
                        isGlobalFilter={true}
                        isAddOptions={false}
                        customPageSize={10}
                        className="custom-header-css"
                    />
                    {loading && <Preloader />}
                </div>
                {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
            </div>
        </div>
    );
}

export default DatatableTables;